export default "__VITE_ASSET__BIZe6q3T__"